import { render } from "./ShowWorkspace.vue?vue&type=template&id=92b43586"
import script from "./ShowWorkspace.vue?vue&type=script&lang=js"
export * from "./ShowWorkspace.vue?vue&type=script&lang=js"

import exportComponent from "D:\\PHPStormProjects\\hqam-customer-portal\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__